<div
  class="user-sidenav-wrapper"
  fxLayout="column"
  fxLayoutAlign="start center"
>
  <div
    id="user-mini-profile"
    fxLayout="column"
    fxLayoutAlign="space-between center"
  >
    <div class="profile-image-wrapper">
      <img
        src="../../../../assets/image/circle-user.svg"
        *ngIf="!userData?.avatar"
        alt=""
      />
      <img
        referrerpolicy="no-referrer"
        [src]="userData.avatar?.url"
        *ngIf="userData?.avatar"
        alt=""
      />
    </div>
    <div
      class="description"
      fxLayout="column"
      fxLayoutAlign="space-around center"
    >
      <strong class="name" *ngIf="userData">
        {{ userData.fullName || "Loading .." }}
      </strong>
    </div>
  </div>

  <mat-nav-list
    id="nav-menu-list"
    fxLayout="column"
    fxLayoutAlign="space-around center"
  >
    <a
      mat-list-item
      class="my-orders list-item"
      routerLinkActive="activated"
      routerLink="/user"
      [routerLinkActiveOptions]="{ exact: true }"
    >
      <jam-icon
        [size]="_listIconSize"
        name="square"
        class="list-item-icon"
      ></jam-icon>
      <span class="list-item-body">داشبورد</span>
    </a>

    <a
      mat-list-item
      routerLinkActive="activated"
      routerLink="/user/my-orders"
      class="my-orders list-item"
    >
      <!-- <jam-icon
        [size]="_listIconSize"
        name="shopping-cart"
        class="list-item-icon"
      ></jam-icon> -->
      <mat-icon svgIcon="cart-shopping" class="blue" />

      <span class="list-item-body">سفارش‌های من</span>
    </a>
    <a
      mat-list-item
      routerLinkActive="activated"
      routerLink="/user/download-orders"
      class="my-orders list-item"
    >
      <jam-icon
        [size]="_listIconSize"
        name="download"
        class="list-item-icon"
      ></jam-icon>

      <span class="list-item-body">سفارش‌های دانلودی</span>
    </a>
    <!-- 
    <a
      mat-list-item
      class="my-orders list-item"
      routerLinkActive="active"
      [routerLink]="['doc/favorite']"
    >
      <jam-icon
        [size]="_listIconSize"
        name="heart-f"
        class="list-item-icon"
      ></jam-icon>
      <span class="list-item-body">
        <span>علاقه مندی‌ها</span>
      </span>
    </a>

    <a
      mat-list-item
      class="my-orders list-item"
      [routerLink]="['doc/list']"
      routerLinkActive="active"
    >
      <jam-icon
        [size]="_listIconSize"
        name="files-f"
        class="list-item-icon"
      ></jam-icon>
      <span class="list-item-body">
        <span> لیست جزوه‌ها</span>
      </span>
    </a> -->

    <a
      mat-list-item
      class="my-orders list-item"
      routerLink="wallet"
      routerLinkActive="activated"
    >
      <jam-icon
        [size]="_listIconSize"
        name="coin"
        class="list-item-icon"
      ></jam-icon>
      <span class="list-item-body">کیف پول</span>
    </a>

    <a
      mat-list-item
      class="my-orders list-item"
      routerLink="setting"
      routerLinkActive="activated"
    >
      <jam-icon
        [size]="_listIconSize"
        name="info"
        class="list-item-icon"
      ></jam-icon>
      <span class="list-item-body">اطلاعات حساب</span>
    </a>

    <a mat-list-item routerLink="/user/addresses" class="my-orders list-item">
      <jam-icon
        [size]="_listIconSize"
        class="list-item-icon"
        name="gps"
      ></jam-icon>
      <span class="list-item-body">مدیریت آدرس‌ها</span>
    </a>
  </mat-nav-list>
</div>
